<script setup lang="ts">
defineProps<{
  title: string
  description?: string
  logoUrl?: string
}>()

defineEmits<{
  (e: 'select'): void
}>()
</script>

<template>
  <div class="partner-offer-card" @click="$emit('select')">
    <img
      v-if="logoUrl"
      :src="logoUrl"
      alt=""
      class="partner-offer-card__logo"
    />

    <div class="partner-offer-card__body">
      <h3 class="partner-offer-card__title">{{ title }}</h3>
      <p v-if="description" class="partner-offer-card__description">{{ description }}</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.partner-offer-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
  border: 1px solid #e6e8eb;
  border-radius: 14px;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;

  &:hover {
    border-color: #b3b8bf;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  }

  &__logo {
    width: 156px;
    height: 100px;
    object-fit: contain;
    flex-shrink: 0;
  }

  &__body {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__title {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #1a1a1a;
  }

  &__description {
    margin: 0;
    font-size: 14px;
    color: #6b7280;
  }
}
</style>
